/* eslint-disable no-console */
import { OnboardingType, OnboardingStep } from "@teaming/common-enums";

// eslint-disable-next-line no-unused-vars
export default ( {
	app,
	authService,
	layouts,
	loadedSlices,
	telemetry,
} ) => {
	const lazyLoadOnboarding3Slice = function( { component, } ) {
		return () => {
			if ( !loadedSlices.has( "@teaming/slice-onboarding3" ) ) {
				return import( "@teaming/slice-onboarding3" ).then( async ( { onboarding3Slice, } ) => {
					onboarding3Slice();
					loadedSlices.set( "@teaming/slice-onboarding3", true );
					return app.component( component );
				} );
			}
			return Promise.resolve( app.component( component ) );
		};
	};

	// eslint-disable-next-line no-magic-numbers
	const NewUserOnboardingStep = OnboardingStep.enumFor( { version: 3, isTeamLead: true, } );
	// eslint-disable-next-line no-magic-numbers
	const InvitedUserOnboardingStep = OnboardingStep.enumFor( { version: 3, isTeamLead: false, } );

	return [
		//
		// v3 routes
		//

		{
			path: "/onboarding/new-user",
			name: "New User Onboarding3",
			component: layouts.BareBonesLayout,
			meta: { title: "slice-onboarding3.routes.newUser.default", },
			children: [
				{
					path: "welcome",
					meta: {
						title: "slice-onboarding3.routes.newUser.welcome",
						onboardingStep: NewUserOnboardingStep.WELCOME,
						onboardingType: OnboardingType.LEAD,
					},
					component: lazyLoadOnboarding3Slice( { component: "NewUserOnboardingHOC", } ),
					beforeEnter( to, from, next ) {
						telemetry.onboarding.lead.welcome();
						next();
					},
				},
				{
					path: "you-and-your-team",
					meta: {
						title: "slice-onboarding3.routes.newUser.team",
						onboardingStep: NewUserOnboardingStep.ABOUT_YOUR_TEAM,
						onboardingType: OnboardingType.LEAD,
					},
					component: lazyLoadOnboarding3Slice( { component: "NewUserOnboardingHOC", } ),
					beforeEnter( to, from, next ) {
						telemetry.onboarding.lead.growthOpportunities();
						next();
					},
				},
				{
					path: "session-signup",
					meta: {
						title: "slice-onboarding3.routes.newUser.session",
						onboardingStep: NewUserOnboardingStep.SESSION_SIGNUP,
						onboardingType: OnboardingType.LEAD,
					},
					component: lazyLoadOnboarding3Slice( { component: "NewUserOnboardingHOC", } ),
					beforeEnter( to, from, next ) {
						// TODO: telemetry
						next();
					},
				},
			],
			beforeEnter: authService.authGuard,
		},

		{
			path: "/onboarding/invited-user",
			name: "Invited User Onboarding3",
			component: layouts.BareBonesLayout,
			meta: { title: "slice-onboarding3.routes.invitedUser.default", },
			children: [
				{
					path: "welcome",
					meta: {
						title: "slice-onboarding3.routes.invitedUser.welcome",
						onboardingStep: InvitedUserOnboardingStep.WELCOME,
						onboardingType: OnboardingType.MEMBER,
					},
					component: lazyLoadOnboarding3Slice( { component: "InvitedUserOnboardingHOC", } ),
					beforeEnter( to, from, next ) {
						telemetry.onboarding.member.welcome();
						next();
					},
				},
				{
					path: "personal-growth",
					meta: {
						title: "slice-onboarding3.routes.invitedUser.growth",
						onboardingStep: InvitedUserOnboardingStep.PERSONAL_GROWTH,
						onboardingType: OnboardingType.MEMBER,
					},
					component: lazyLoadOnboarding3Slice( { component: "InvitedUserOnboardingHOC", } ),
					beforeEnter( to, from, next ) {
						telemetry.onboarding.member.growthOpportunities();
						next();
					},
				},
			],
			beforeEnter: authService.authGuard,
		},
	];
};
